export default __webpack_public_path__ + "static/media/c5b78520f90fc8360f6fa4d60ad2bc9a.4143fb04.svg";